import { linkConvite } from './basePath';

/**
 * Mensagem pré-escrita de compartilhamento (UX §5.3). Voz de pessoa falando com
 * amigo; o benefício do amigo vem **antes** do brinde de quem indica
 * (reciprocidade, UX §3). Editável pelo cliente antes de enviar. Sem emoji na
 * UI; no texto do WhatsApp, no máximo um — hoje nenhum, até OK do dono (D4).
 */
export function mensagemIndicacao(codigo: string, brindeIndicado: string | null): string {
  const brinde = brindeIndicado ?? 'um brinde de boas-vindas';
  return (
    `Fala! Faço os serviços do meu carro na Varga Car Service e recomendo de olhos ` +
    `fechados. Quando você for fazer um serviço, usa meu código ${codigo} — você ganha ` +
    `${brinde} e eu ganho um brinde também.\n` +
    linkConvite(codigo)
  );
}
